module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/restaurants_4-4522d1dc455fafe5e36eac4bfa927270.jpg";